import { Layout } from "antd";
import { useTranslation } from "react-i18next";
import HomePageAgencySection from "../../../components/HomePageAgencySection/HomePageAgencySection";
import HomePageAnimatedSection from "../../../components/HomePageAnimatedSection/HomePageAnimatedSection";
import HomePageBecomeCreatorSection from "../../../components/HomePageBecomeCreatorSection/HomePageBecomeCreatorSection";
import HomePageCreatorSection from "../../../components/HomePageCreatorSection/HomePageCreatorSection";
import HomePageFooter from "../../../components/HomePageFooter/HomePageFooter";
import HomePageHeroSection from "../../../components/HomePageHeroSection/HomePageHeroSection";
import HomePageNavbarComponent from "../../../components/HomePageNavbarComponent/HomePageNavbarComponent";
import HomePageQuestionSection from "../../../components/HomePageQuestionSection/HomePageQuestionSection";
import HomePageSecuritySection from "../../../components/HomePageSecuritySection/HomePageSecuritySection";
import useHomePageInfos from "../../../hooks/global/useHomePageInfos";
import usePublicPageSeo from "../../../hooks/global/usePublicPageSeo";
import "./index.less";

const HomePage = () => {
  const { t } = useTranslation();
  useHomePageInfos(t);
  usePublicPageSeo({ path: "/" });

  return (
    <Layout className="HomePageWrapper">
      <HomePageNavbarComponent />
      <HomePageHeroSection />
      <HomePageBecomeCreatorSection />
      <HomePageAnimatedSection />
      <HomePageAgencySection />
      <HomePageSecuritySection />
      <HomePageCreatorSection />
      <HomePageQuestionSection />
      <HomePageFooter />
    </Layout>
  );
};

export default HomePage;
